var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFigmaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2931_44078)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1ABCFE",
    d: "M10 14.9997C10 12.2932 12.2158 10.0991 14.9491 10.0991C17.6824 10.0991 19.8982 12.2932 19.8982 14.9997C19.8982 17.7062 17.6824 19.9003 14.9491 19.9003C12.2158 19.9003 10 17.7062 10 14.9997Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0ACF83",
    d: "M0.101807 24.801C0.101807 22.0945 2.31759 19.9004 5.0509 19.9004H10V24.801C10 27.5075 7.78424 29.7015 5.0509 29.7015C2.31759 29.7015 0.101807 27.5075 0.101807 24.801Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF7262",
    d: "M10 0.29834V10.0995H14.9491C17.6824 10.0995 19.8982 7.90542 19.8982 5.19891C19.8982 2.4924 17.6824 0.29834 14.9491 0.29834H10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F24E1E",
    d: "M0.101807 5.19891C0.101807 7.90542 2.31759 10.0995 5.0509 10.0995H10V0.29834H5.0509C2.31759 0.29834 0.101807 2.4924 0.101807 5.19891Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A259FF",
    d: "M0.101807 14.9997C0.101807 17.7062 2.31759 19.9003 5.0509 19.9003H10V10.0991H5.0509C2.31759 10.0991 0.101807 12.2932 0.101807 14.9997Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2931_44078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 29.7059,
    fill: "#fff",
    transform: "translate(0 0.146973)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaLogo);
export default __webpack_public_path__ + "static/media/figma-logo.c51bea044c7b4d2588360b8ed39f04d0.svg";
export { ForwardRef as ReactComponent };